import React, { useEffect, useState } from "react";
import { Table, Tag, Alert, Button, Row, Col, Space, Empty } from "antd";
import { RedoOutlined } from "@ant-design/icons";
import { useLoading } from "context/loadingContext";
import { bg_button, bg_shadow } from "constant/css";
import { ListMyFeeShareRules } from "functions/merchant/feeShareRule";

// READ-ONLY view
// Merchant өөрөө дүрэм нэмэх/засах боломжгүй — зөвхөн харна.
// Тохиргоог админ талаас хийнэ.
const MerchantFeeShareRule = () => {
  const { showLoading, hideLoading } = useLoading();
  const [rules, setRules] = useState([]);
  const [summary, setSummary] = useState({
    totalActivePercent: 0,
    isValid: false,
    activeCount: 0,
    willSplit: false,
  });

  useEffect(() => {
    fetchRules();
  }, []);

  const fetchRules = async () => {
    showLoading();
    try {
      const response = await ListMyFeeShareRules();
      if (response) {
        setRules(response.data || []);
        setSummary(
          response.summary || {
            totalActivePercent: 0,
            isValid: false,
            activeCount: 0,
            willSplit: false,
          }
        );
      }
    } finally {
      hideLoading();
    }
  };

  const columns = [
    { title: "#", dataIndex: "id", width: 60 },
    {
      title: "Хүлээн авагч",
      dataIndex: "recipientName",
      render: (v) => v || "-",
    },
    { title: "Данс", dataIndex: "accountNumber" },
    { title: "Банкны код", dataIndex: "bankCode", width: 110 },
    {
      title: "Хувь",
      dataIndex: "percent",
      width: 90,
      align: "right",
      render: (v) => <Tag color="blue">{parseFloat(v)}%</Tag>,
    },
    {
      title: "Идэвхтэй",
      dataIndex: "active",
      width: 110,
      render: (v) =>
        v ? (
          <Tag color="cyan">Идэвхтэй</Tag>
        ) : (
          <Tag color="default">Идэвхгүй</Tag>
        ),
    },
    {
      title: "Тайлбар",
      dataIndex: "description",
      render: (v) => v || "-",
    },
  ];

  const renderStatus = () => {
    if (summary.activeCount === 0) {
      return (
        <Alert
          type="info"
          showIcon
          message="Тооцоо хуваарилалт идэвхгүй"
          description="Тохируулсан дүрэм байхгүй тул өндөрлөгөө танай үндсэн данс руу бүхэлд нь шилжих болно."
        />
      );
    }
    if (!summary.isValid) {
      return (
        <Alert
          type="warning"
          showIcon
          message={`Дүрмүүдийн нийлбэр = ${summary.totalActivePercent}% (100% байх ёстой)`}
          description="100% болоогүй учир хуваарилалт идэвхжихгүй. Тохиргоо засуулахаар админтай холбогдоно уу."
        />
      );
    }
    return (
      <Alert
        type="success"
        showIcon
        message={`Тооцоо хуваарилалт идэвхтэй (${summary.activeCount} дүрэм, 100%)`}
        description="Өндөрлөгөө хийгдэхэд авах шимтгэл доорх дүрмийн дагуу хуваагдаж тус тусын данс руу шилжих болно."
      />
    );
  };

  return (
    <div className={`p-4 bg-white rounded-xl ${bg_shadow}`}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
        <Col>
          <h2 className="font-semibold text-lg">Тооцоо хуваарилалтын дүрэм</h2>
          <span className="text-xs text-gray-500">
            Зөвхөн харах горим — тохиргоо засуулахаар админтай холбогдоно уу
          </span>
        </Col>
        <Col>
          <Space>
            <Button
              icon={<RedoOutlined />}
              onClick={fetchRules}
              className={`${bg_button} text-white`}
            >
              Шинэчлэх
            </Button>
          </Space>
        </Col>
      </Row>

      <div style={{ marginBottom: 12 }}>{renderStatus()}</div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={rules}
        size="small"
        pagination={false}
        locale={{
          emptyText: <Empty description="Тохируулсан дүрэм байхгүй" />,
        }}
      />
    </div>
  );
};

export default MerchantFeeShareRule;
